<template>
    <div class="hr">
        <el-card>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>人力资源</el-breadcrumb-item>
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.name" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
<!--                    <el-form-item label="邮箱域名">-->
<!--                        <el-input v-model="searchForm.domain" placeholder="邮箱域名" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item>
                        <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" border>
                    <el-table-column type="index" label="序号" width="50"/>
<!--                    <el-table-column prop="code" label="公司代码">-->
<!--                    </el-table-column>-->
                    <el-table-column prop="name" label="公司名称"  width="200">
                    </el-table-column>
<!--                    <el-table-column prop="domain" label="邮箱域名"/>-->
                    <el-table-column prop="departments" label="部门" width="210"  class-name="params" >
                        <template slot-scope="scope">
                            <template
                                    v-if="scope.row.departments!=null && scope.row.departments!=[]">
                                <el-table :row-style="{height:'20px'}" :cell-style="{padding: '0'}"
                                          :data="scope.row.departments" :show-header=false  max-height="200" style="width: 100%;height:100%;">
                                     <el-table-column prop="name" align="center" label="名称" :show-overflow-tooltip="true"></el-table-column>

                                    <el-table-column label="操作" width="90" align="right">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="mini"
                                                       @click="handleEditDep(scope.row)">修改</el-button>
                                            <el-divider direction="vertical" ></el-divider>
                                            <el-button type="text" size="mini"
                                                                                @click="deleteDep(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </template>

                    </el-table-column>
<!--                    <el-table-column prop="users" label="人员" width="250"  :show-overflow-tooltip="true" class-name="params" >-->
                    <el-table-column prop="users" label="人员" width="400"  class-name="params" >
<!--                        <template slot-scope="scope">-->
<!--                            {{ scope.row.users.map(it => it.name).join()}}-->
<!--                        </template>-->

                        <template slot-scope="scope">
                            <template
                                    v-if="scope.row.users!=null && scope.row.users!=[]">
                                <el-table :row-style="{height:'20px'}" :cell-style="{padding: '0'}" :data="scope.row.users" :show-header=false  max-height="200" style="width: 100%;height:100%;">
<!--                                    <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>-->
                                    <el-table-column prop="name" align="center" label="姓名"  width="100" :show-overflow-tooltip="true"></el-table-column>
                                    <el-table-column prop="email" align="center" label="邮箱" :show-overflow-tooltip="true" width="100" ></el-table-column>
                                    <el-table-column prop="type" label="" width="50">
                                        <template slot-scope="scope">
                                            {{ scope.row.type==0?"前台":"后台"}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="100" align="right">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="mini"
                                                       @click="handlePeople(scope.row)">修改</el-button>
                                            <el-divider direction="vertical" ></el-divider>
                                            <el-button type="text" size="mini"
                                                  @click="handleDelete(scope.row)">删除</el-button>

                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </template>

                    </el-table-column>
                    <el-table-column label="操作" width="80" align="center">
                        <template slot="header">
<!--                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>-->
                        </template>
                        <template slot-scope="scope">
                            <div>
                                <el-button size="mini"   @click="handleEdit(scope.$index, scope.row)">人员</el-button>
                                <br/>
                                <el-button size="mini" type="primary"   @click="handleCreate(scope.row.id)" >部门</el-button>
                            </div>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background
                                   layout="sizes,prev, pager, next"
                                   :total="total"
                                   :page-sizes="[10, 20, 50, 100]"
                                   v-if="total>0"
                                   @size-change="handleSizeChange"
                        :page-size="pageSize" @current-change="onPageChange" @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="添加员工" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-form-item label="公司代码" prop="code">
                    <el-input v-model="editForm.code" placeholder="请输入公司代码" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入公司名称" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="部门名称" prop="departmentId">
                    <el-select v-model="editForm.departmentId"  placeholder="部门名称">
                        <el-option
                                v-for="item in editForm.departments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button size="mini"  @click="add()">添加</el-button>
                <el-table :data="userData" v-loading="loading" style="width: 100%" :height="300"
                          @selection-change="handleSelectionChange">
<!--                    <el-table-column type="index" label="序号" width="50"/>-->
                    <el-table-column type="selection" width="55"/>
                    <el-table-column prop="name" label="姓名"  width="100"/>
                    <el-table-column prop="email" label="邮箱">
                    </el-table-column>
                    <el-table-column prop="mobile" label="手机">
                    </el-table-column>
                    <el-table-column prop="type" label="" width="50">
                        <template slot-scope="scope">
                            {{ scope.row.type==0?"前台":"后台"}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
<!--                <el-button type="primary" @click="onSubmit">确 定</el-button>-->
            </div>
        </el-dialog>

        <el-dialog title="部门信息" :visible.sync="depDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="depForm" :model="depForm" :rules="rules2" label-width="100px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="depForm.name" placeholder="请输入名称" maxlength="28" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="depForm.remark" placeholder="请输入备注" maxlength="100" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="depDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">添 加</el-button>
            </div>
        </el-dialog>
        <el-dialog title="员工信息" :visible.sync="infoVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="peopleForm" :model="peopleForm" :rules="rules" label-width="100px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="peopleForm.name"  disabled style="width: 300px" clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="companyId">
                    <el-select v-model="peopleForm.companyId"  placeholder="公司名称" @change="selectChanged" style="width: 300px">
                        <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门名称" prop="departmentId">
                    <el-select v-model="peopleForm.departmentId"  placeholder="部门名称" style="width: 300px">
                        <el-option
                                v-for="item in peopleForm.departments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="infoVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPeople">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {

    data() {
        return {
            companys:[],
            selectData:[],
            userData:[],
            deps:[],
            depForm: {
                id: "",
                name: "",
                companyId: "",
                remark: ""

            },
            depDialogVisible: false,
            infoVisible: false,
            searchForm: {
                name: "",
                domain: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            fileList: [],
            editForm: {
                departmentId: "",
                departments: "",
                id: "",
                code: "",
                name: "",
                domain: ""
            },
            oldPeople:{},
            peopleForm: {
                departmentId: "",
                id: "",
                type: "",
                departments: [],
                name: "",
                companyId: ""
            },
            editInvoiceDialogVisible: false,
            editInvoiceForm: {
                id: "",
                companyId: "",
                type: "0",
                companyTaxNo: "",
                bankName: "",
                bankAccount: "",
                registeredTel: "",
                registeredAddress: "",
            },
            options: [],
            rules: {
                code: [
                    { required: true, message: '请输入公司代码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                domain: [
                    { required: true, message: '请输入邮箱域名', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择发票类型', trigger: 'blur' }
                ]

            },
            rules2: {

                name: [
                    { required: true, message: '请输入部门名称', trigger: 'blur' }
                ]


            }
        }
    },
    methods: {
        onSearch() {
            let company = {
            };
            if (this.searchForm.name != "") {
                company["name"] = this.searchForm.name;
            }
            if (this.searchForm.domain != "") {
                company["domain"] = this.searchForm.domain;
            }
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/company/userList", {
                cond: company,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
            });
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handlePeople(row) {
            this.peopleForm.id = row.id;
            this.peopleForm.name = row.name;
            this.peopleForm.type = row.type;
            this.peopleForm.companyId = row.companyId;
            if(row.companyId != null && row.companyId != ""){
                let d =  this.deps.filter(it => it.companyId==row.companyId);
                this.peopleForm.departments = d;
            }
            this.peopleForm.departmentId = row.departmentId;
            this.oldPeople =  {...this.peopleForm};
            this.infoVisible = true;
        },
        handleCreate(companyId) {
            this.depForm.id = "";
            this.depForm.companyId = companyId;
            this.depForm.name = "";
            this.depForm.remark = "";
            this.depDialogVisible = true;
        },
        handleEditDep(row) {
            this.depForm.id = row.id;
            this.depForm.name = row.name;
            this.depForm.remark = row.remark;
            this.depDialogVisible = true;
        },
        onSubmit() {
            let _this = this;
            this.$refs.depForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/company/addDep", this.depForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.depDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.code = row.code;
            this.editForm.name = row.name;
            this.editForm.domain = row.domain;
            this.editForm.departments = row.departments;
            this.editForm.departmentId = "";
            this.loadUser();
            this.editDialogVisible = true;
        },
        handleUpload(index, row) {
            this.editForm.id = row.id;
            this.uploadDialogVisible = true;
        },
        add() {
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要添加的员工',
                    duration: 1000
                });
                return;
            }
            let users = [];
            for(let i=0; i<this.selectData.length; i++){
                users.push( {companyId:this.editForm.id,userId:this.selectData[i].id,
                    type:this.selectData[i].type,departmentId:this.editForm.departmentId});
            }

            let msg =  this.selectData.map(it => it.name?it.name:it.email).join(",");
            let _this = this;
            this.$confirm('是否添加员工【' + msg + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post("/admin/company/addUser",users)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '添加成功',
                                type: 'success'
                            });
                            _this.editDialogVisible = false
                            _this.loadUser();
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
         editPeople() {//编辑人员所属公司和部门

            if(this.peopleForm.departmentId == this.oldPeople.departmentId
            &&this.peopleForm.companyId == this.oldPeople.companyId){
                this.infoVisible = false;
                return;
            }
            let users = [{id:this.peopleForm.id,companyId:this.peopleForm.companyId,
                 departmentId:this.peopleForm.departmentId}];
             let _this = this;
             this.$confirm('是否修改员工信息？', '确认信息', {
                 distinguishCancelAndClose: true,
                 confirmButtonText: '确认',
                 cancelButtonText: '取消'
             }).then(() => {
                 _this.$axios.post("/admin/company/addUser",users)
                     .then(function (response) {
                         let resp = response.data;
                         if (resp.header.status === 0) {
                             _this.$notify({
                                 title: '成功',
                                 message: '修改成功',
                                 type: 'success'
                             });
                             _this.infoVisible = false
                             _this.onSearch();
                         } else {
                             _this.$notify.error({
                                 title: '错误',
                                 message: resp.header.msg
                             });
                         }
                     });
             })
        },

        loadUser(){
            let _this = this
            this.$axios.post("/admin/company/users"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.userData = resp.data;
                }

                });

        },
        loadDep(){
            let _this = this
            this.$axios.post("/admin/company/allDep"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.deps = resp.data;
                }

            });

        },
        handleDelete(row) {
            let _this = this;
            this.$confirm('是否删除用户【' + row.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post("/admin/company/deleteUser",{companyId: row.companyId,userId:row.userId,type:row.type})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        deleteDep(row) {
            let _this = this;
            this.$confirm('是否删除【' + row.name + '】部门？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post("/admin/company/deleteDep",row.id)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        loadCompany(){
            let _this = this
            this.$axios.post("/admin/company/all"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        selectChanged(companyId) {
            if(companyId != null && companyId != ""){
                let d =  this.deps.filter(it => it.companyId == companyId);
                this.peopleForm.departments = d;
                this.peopleForm.departmentId = null;

            }

        }
    },
    created() {
        const that = this;
        this.$axios.post("/admin/rights/staff/list", { type: 1 })
            .then(function (response) {
                const resp = response.data;
                if (resp.header.status == 0) {
                    that.options = resp.data;
                    that.onSearch();
                }
            }).catch(function () {
            });
        that.loadCompany();
        that.loadDep();
    },
}
</script>
<style>
    .el-tooltip__popper{
        max-width:500px !important;
    }
    .table ::v-deep .el-table--medium .el-table__cell {
        padding: 0px !important;
    }
    ::v-deep .params .cell {
        padding: 0px !important;
        border: none;
    }

</style>
